import React, { useMemo } from 'react';
import { getLocale, useIntl } from 'umi';
// import { Bubble, Icon, Modal } from 'tea-component';
import { Bubble, Button } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import ReportSourceLabel from '@intelligence/components/ReportSourceLabel';
import useData from './_hook';
import { getLangOfReportDetails } from '@intelligence/v3/utils/reports';
import {
  previewMarkdown,
  filterMarkdown,
  handleLinkerTarget,
  getCurrentRoutePath,
} from '@intelligence/utils/commonUtils';
import {
  dbiBtnLogMes,
  // dbiPageLogMes,
} from '@intelligence/utils/buriedPointCfg';
import { buriedBtnPoint } from '@home/utils/buriedPoint';
import { getReportResourcePath } from '@intelligence/utils/reports';
import { openPDFPreviewDownloadPage, getReportPreviewFileName } from './utils';

import ExpandableSummary from './ExpandableSummary';
import './markdown.scss';
import './index.scss';

import DataBrain from '@home/assets/svg/dataSource/databarin.svg';

const databrainIcon = <img src={DataBrain} className="dbi-source-label-new-icon" />;

export default function ReportCard(props: any) {
  const {
    // getReportShow,
    // reportUrl,
    data,
    isNew,
    hasPDF,
    systemId,
    // setShowDetail,
    // showDetail,
    jumpTo,
    // reportLoading,
    // downloadReports,
    isMur,
    type,
    handleDownloadRun,
  } = useData(props);
  const {
    studioId,
    reportTypeConfig,
    allowHtmlInLabels = false,
    reportLangSegment,
    topRightRender,
    badgeRender,
    displaySource = data?.source,
    summaryExpandable = false,
  } = props || {};
  const locale = getLocale();
  const { formatMessage } = useIntl();

  // 报告的语种
  const reportLang = useMemo<'en' | 'cn'>(() => {
    return getLangOfReportDetails(locale, reportLangSegment);
  }, [locale, reportLangSegment]);

  const [downloading, setDownloading] = React.useState(false);
  const markdownPreviewContent = useMemo<string>(() => {
    if (!isMur) return data?.summary;
    return previewMarkdown(data?.summary?.replace(/\t/g, '')?.replace(/\\n/g, '\n'));
  }, [isMur, data]);

  const bubbleContent = useMemo<string>(() => {
    if (!isMur) return markdownPreviewContent;
    return handleLinkerTarget(markdownPreviewContent);
  }, [isMur, markdownPreviewContent]);

  const content = useMemo<string>(() => {
    if (!isMur) return markdownPreviewContent;
    return filterMarkdown(markdownPreviewContent);
  }, [isMur, markdownPreviewContent]);

  // const buriedBtnPointMarket = (data: any) => {
  //   if (dbiPageLogMes?.[props?.tabPointInfo]) {
  //     const pageInfo = dbiPageLogMes?.[props?.tabPointInfo];
  //     const btnMsgInfo = {
  //       pageId: pageInfo?.pageId,
  //       buttonId: `${pageInfo?.pageId}001`,
  //       // extInfo: `${data.resource_id}-${data.title}`,
  //       extInfo: `${data.resource_id}-${data.originTitle || data.title}`,
  //       typeId: pageInfo.typeId,
  //     };
  //     buriedBtnPoint(btnMsgInfo);
  //   }
  // };

  const renderSourceLabel = ({ source }: { source: string; }) => {
    const isDataBrain = !!(source?.toLowerCase() === 'databrain' || source?.toLocaleLowerCase() === 'newzoo');

    const sourceLabel = isDataBrain ? (
      <div className="dbi-reportcard-source">
        <ReportSourceLabel
          // sourceName="Newzoo"
          needCustomName
          customName="DataBrain"
          needCustomIcon
          customIcon={databrainIcon}
        />
      </div>
    ) : (
      <div className="dbi-reportcard-source">
        <ReportSourceLabel sourceName={source} />
      </div>
    );

    return sourceLabel;
  };

  return (
    <>
      {/* {hasPDF ? (
        //  详情pdf弹窗
        <Modal
          className="dbi-reportcard-modal"
          disableCloseIcon
          visible={showDetail}
        >
          <div className="tea-dialog__header">
            <h3 className="tea-dialog__headertitle">{data.title}</h3>
            <div className="dbi-reportcard-modal-iconbox">
              <div
                className="dbi-reportcard-modal-download dbi-reportcard-modal-icon"
                onClick={() => {
                  // console.log("download")
                  downloadReports(data.resource_id)

                  if (type === 'Market' || type === 'Mobile') {
                    const BtnLogMes = type == 'Market' ? dbiBtnLogMes.MarketReportsDownload : dbiBtnLogMes.mobileDeviceReportsDownload;
                      BtnLogMes.extInfo = data.title;

                      buriedBtnPoint(BtnLogMes)
                  }
                }}
              >
                <SvgIcon type="download" />
              </div>
              <div
                className="dbi-reportcard-modal-close dbi-reportcard-modal-icon"
                onClick={() => setShowDetail(!showDetail)}
              >
                <SvgIcon type="clonse" />
              </div>
            </div>
          </div>
          <Modal.Body>
            <div className="dbi-reportcard-modal-pdf">
              <div
                className={
                  reportLoading
                    ? 'report-loading'
                    : 'report-loading-none'
                }
              >
                <Icon size="l" type="loading" />
                &nbsp;&nbsp;&nbsp;Loading…
              </div>
              {
                !reportLoading &&
                <iframe
                  className="dbi-reportcard-modal-pdfinner"
                  src={reportUrl}
                ></iframe>
              }
            </div>
          </Modal.Body>
        </Modal>
      ) : null} */}
      <div
        className="dbi-reportcard"
        onClick={() => {
          if (hasPDF) {
            if (type === 'Market' || type === 'Mobile') {
              // getReportShow(systemId, data.resource_id, reportLang);
              // setShowDetail(true);

              // 打点转移到打开的报告页面
              // if(type == 'Market'){
              //   buriedBtnPointMarket(data)
              // }else{
              //   const BtnLogMes = dbiBtnLogMes.mobileDeviceReportsDetail;
              //   BtnLogMes.extInfo = data.title;

              //   buriedBtnPoint(BtnLogMes)
              // }

              // studio专区report卡片跳转
              if (studioId && data?.resource_id) {
                const { systemIdCur, downloadLogKeyCur } = reportTypeConfig || {};
                const resourcePath = getReportResourcePath(locale, { ...data, lang: reportLang });
                const fileName = getReportPreviewFileName(resourcePath, data);
                return openPDFPreviewDownloadPage('/pdfPreviewDownload', {
                  studioId,
                  id: data?.id,
                  systemId: systemIdCur,
                  resourceId: data.resource_id,
                  // resourceName: data.title,
                  resourceName: data.originTitle || data.title,
                  resourcePath,
                  fileName,
                  downloadLogKey: downloadLogKeyCur,
                  lang: reportLang,
                });
              }

              const resourcePath = getReportResourcePath(locale, { ...data, lang: reportLang });
              openPDFPreviewDownloadPage('/pdfPreviewDownload', {
                id: data?.id,
                systemId,
                resourceId: data.resource_id,
                // resourceName: data.title,
                resourceName: data.originTitle || data.title,
                resourcePath,
                downloadLogKey: type === 'Market' ? 'MarketReportsDownload' : 'mobileDeviceReportsDownload',
                referer: getCurrentRoutePath(),
                lang: reportLang,
              });
            }
          } else {
            if (data?.link && isMur) {
              jumpTo(data.link);
              const BtnLogMes = dbiBtnLogMes.iMurReportsUrl;
              // BtnLogMes.extInfo = data.title;
              BtnLogMes.extInfo = data.originTitle || data.title;

              buriedBtnPoint(BtnLogMes);
            }
          }
        }}
      >
        {topRightRender?.()}
        <img className="dbi-reportcard-img" src={data.coverImg == 'error' ? '' : data.coverImg} />
        <div className="dbi-reportcard-infobox">
          <div className={`dbi-reportcard-title ${data.attachment ? 'dbi-reportcard-title-with-download' : ''}`}>
            {/* <div className="dbi-reportcard-tit"><{data.title}></div> */}
            <div className="dbi-reportcard-title">
              <div className="dbi-reportcard-tit">
                <span dangerouslySetInnerHTML={{ __html: data.title }} />
              </div>
              {hasPDF ? null : <SvgIcon className="dbi-reportcard-share" type="other-share-icon" />}
              {isNew ? <div className="dbi-reportcard-notice">NEW</div> : null}
            </div>
            {data.attachment ? (
              <Button
                className="dbi-market-report-download-btn"
                loading={downloading}
                disabled={downloading}
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onClick={async (e) => {
                  e?.stopPropagation();
                  setDownloading(true);
                  await handleDownloadRun?.(data.id, data.attachment);
                  setDownloading(false);
                }}
              >
                <SvgIcon className="dbi-market-report-download-btn-icon" type="download" />
                {formatMessage({ id: 'dbi_market_report-download' })}
              </Button>
            ) : null}
          </div>
          {badgeRender?.()}
          {summaryExpandable ? (
            <ExpandableSummary
              html={content}
              className="dbi-reportcard-des"
              maxLines={3}
            />
          ) : (
            <Bubble
              overlayClassName="dbi-report-markdown-bubble-overlay"
              style={{ maxWidth: 500 }}
              dark
              content={
                <div
                  className="dbi-markdown-report-content dbi-report-markdown-body"
                  dangerouslySetInnerHTML={{ __html: bubbleContent }}
                  onClick={(e) => {
                    e?.stopPropagation();
                  }}
                ></div>
              }
            >
              <div
                className="dbi-reportcard-des"
                dangerouslySetInnerHTML={{ __html: content }}
              ></div>
            </Bubble>
          )}
          <div className="dbi-reportcard-info">
            <span className="dbi-reportcard-time">{data.time}</span>
            {data.type ? <span className="dbi-reportcard-type">{data.type}</span> : null}
            {data.labelList ? (
              <div className="dbi-reportcard-labelbox">
                {data.labelList.map((item: any, index: number) => {
                  return allowHtmlInLabels ? (
                    <span className="dbi-reportcard-label" key={index} dangerouslySetInnerHTML={{ __html: item }} />
                  ) : (
                    <span className="dbi-reportcard-label" key={index}>
                      {item}
                    </span>
                  );
                })}
              </div>
            ) : null}
            {/* {data.source ? (
              <div className="dbi-reportcard-source">
                <ReportSourceLabel sourceName={data.source} />
              </div>
            ) : null} */}
            {displaySource ? renderSourceLabel({ source: displaySource }) : null}
          </div>
        </div>
      </div>
    </>
  );
}
